export default function LockIcon() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.33333 9.41667C8.33333 9.55474 8.2214 9.66667 8.08333 9.66667C7.94526 9.66667 7.83333 9.55474 7.83333 9.41667M5.75 5.5V3.25C5.75 2.65326 5.98705 2.08097 6.40901 1.65901C6.83097 1.23705 7.40326 1 8 1C8.59674 1 9.16903 1.23705 9.59099 1.65901C10.0129 2.08097 10.25 2.65326 10.25 3.25V5.5M8.83333 9.41667C8.83333 9.83088 8.49755 10.1667 8.08333 10.1667C7.66912 10.1667 7.33333 9.83088 7.33333 9.41667C7.33333 9.00245 7.66912 8.66667 8.08333 8.66667C8.49755 8.66667 8.83333 9.00245 8.83333 9.41667ZM3 5.5H13C13.2761 5.5 13.5 5.72386 13.5 6V13C13.5 13.2761 13.2761 13.5 13 13.5H3C2.72386 13.5 2.5 13.2761 2.5 13V6C2.5 5.72386 2.72386 5.5 3 5.5Z"
          stroke="#11A75C"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
